// @ts-nocheck
import { AdjustPairsGridDefConfig } from './types.js';

export const QUALITY_OPTIONS = ['', 'Q1', 'Q2', 'Q3', 'Q4', 'Q5', 'Q6'] as const;

export const CONDITION_OPTIONS = ['', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6'] as const;

// Some of the adjustKeys below are commented out due to weirdness with AdjustTerms
export const ADJUST_PAIRS_GRID_DEF: Readonly<AdjustPairsGridDefConfig[]> = [
  {
    propertyKey: 'salePrice',
    label: 'Sale Price',
    inputType: 'number',
  },
  {
    propertyKey: 'financialConcessionAmount',
    adjustKey: 'financialConcessionsManual',
    label: 'Financial Concession Amount',
    inputType: 'number',
  },
  {
    propertyKey: 'closeDate',
    adjustKey: 'dateOfSaleManual',
    label: 'Close Date',
    inputType: 'date',
  },
  {
    propertyKey: 'site',
    adjustKey: 'siteManual',
    label: 'Site',
    inputType: 'number',
  },
  {
    propertyKey: 'locationFactorOne',
    adjustKey: 'locationManual',
    label: 'Location',
    inputType: 'text',
    // inputType: 'select',
    // options: LOCATION_OPTIONS,
  },
  {
    propertyKey: 'viewFactorOne',
    adjustKey: 'viewManual',
    label: 'View',
    inputType: 'text',
    // inputType: 'select',
    // options: VIEW_OPTIONS,
  },
  {
    propertyKey: 'designStyle',
    adjustKey: 'designManual',
    label: 'Design/Style',
    inputType: 'text',
  },
  {
    propertyKey: 'quality',
    adjustKey: 'qualityManual',
    label: 'Quality',
    inputType: 'select',
    options: QUALITY_OPTIONS,
  },
  {
    propertyKey: 'age',
    adjustKey: 'ageManual',
    label: 'Age',
    inputType: 'number',
  },
  {
    propertyKey: 'condition',
    adjustKey: 'conditionManual',
    label: 'Condition',
    inputType: 'select',
    options: CONDITION_OPTIONS,
  },
  {
    propertyKey: 'grossLivingArea',
    adjustKey: 'grossLivingAreaManual',
    label: 'Gross Living Area',
    inputType: 'number',
  },
  {
    propertyKey: 'aboveGradeBedroomCount',
    adjustKey: 'aboveGradeBedroomCount',
    label: 'Above Grade Bedrooms',
    inputType: 'count',
  },
  {
    propertyKey: 'aboveGradeFullBathCount',
    adjustKey: 'aboveGradeFullBathCount',
    label: 'Above Grade Full Baths',
    inputType: 'count',
  },
  {
    propertyKey: 'aboveGradeHalfBathCount',
    adjustKey: 'aboveGradeHalfBathCount',
    label: 'Above Grade 1/2 Baths',
    inputType: 'count',
  },
  {
    propertyKey: 'totalBasementArea',
    adjustKey: 'totalBasementAreaManual',
    label: 'Total Basement Area',
    inputType: 'count',
  },
  {
    propertyKey: 'finishedBasementArea',
    adjustKey: 'finishedBasementAreaManual',
    label: 'Finished Basement Area',
    inputType: 'number',
  },
  {
    propertyKey: 'attachedGarageParkingSpacesCount',
    adjustKey: 'garageParkingSpacesCount',
    label: 'Garage Spaces',
    inputType: 'count',
  },
  {
    propertyKey: 'carportParkingSpacesCount',
    adjustKey: 'carportParkingSpacesCount',
    label: 'Carport Spaces',
    inputType: 'count',
  },
  {
    propertyKey: 'porchPatioDeck',
    adjustKey: 'porchPatioDeckManual',
    label: 'Porch/Patio/Deck',
    inputType: 'text',
  },
  {
    propertyKey: 'additionalFeature1Description',
    adjustKey: 'additionalFeature1',
    labelKey: 'additionalFeature1Title',
    label: 'Additional Features 1',
    inputType: 'text',
  },
  {
    propertyKey: 'additionalFeature2Description',
    adjustKey: 'additionalFeature2',
    labelKey: 'additionalFeature2Title',
    label: 'Additional Features 2',
    inputType: 'text',
  },
  {
    propertyKey: 'additionalFeature3Description',
    adjustKey: 'additionalFeature3',
    labelKey: 'additionalFeature3Title',
    label: 'Additional Features 3',
    inputType: 'text',
  },
];
